module.exports = __webpack_public_path__ + "img/tree-07-a-leaves.0fa36bcf.png";